import type { SocialMediaCarouselItem } from 'types/capi/modules';

import Image from '~/components/Image';
import {
  InstagramIcon,
  TikTokIcon,
  TssSocialIcon,
  TswSocialIcon
} from '~/components/Social/SocialMediaIcon';
import Tracked from '~/components/Tracked';

type Props = {
  isCurrent: boolean;
  onUnfocusedClick?: () => void;
  slide: SocialMediaCarouselItem;
};

function BusinessIcon({ business }: { business: 'tss' | 'tsw' }) {
  switch (business) {
    case 'tss':
      return <TssSocialIcon />;
    case 'tsw':
      return <TswSocialIcon />;
  }
}

function SourceIcon({ source }: { source: 'instagram' | 'tiktok' }) {
  switch (source) {
    case 'instagram':
      return <InstagramIcon />;
    case 'tiktok':
      return <TikTokIcon />;
  }
}

export default function Slide({ slide, isCurrent, onUnfocusedClick }: Props) {
  function onClick(e: React.MouseEvent<HTMLAnchorElement>) {
    if (isCurrent) return;

    e.preventDefault();
    if (onUnfocusedClick) {
      onUnfocusedClick();
    }
  }

  return (
    <Tracked.ExternalLink
      href={slide.source_url}
      name="SOCIAL_MEDIA_CAROUSEL"
      pagePosition="Social Media Carousel"
      target="__blank"
      onClick={onClick}
      variant="none"
      className={`w-full cursor-pointer ${isCurrent ? 'opacity-100 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.16)]' : 'scale-90 opacity-40'} transition duration-300 ease-in-out`}
    >
      <Content slide={slide} />
    </Tracked.ExternalLink>
  );
}

function Content({ slide }: { slide: Props['slide'] }) {
  return (
    <div className="relative h-[450px] w-[360px] overflow-hidden">
      <Image
        src={slide.image.url}
        alt={slide.image.alt}
        className="size-full object-cover"
        loading="lazy"
      />
      <div className="absolute left-2 top-4">
        <BusinessIcon business={slide.business} />
      </div>
      <div className="absolute bottom-2 right-4">
        <SourceIcon source={slide.source} />
      </div>
    </div>
  );
}
